import NoContent from './NoContent.jsx';

export {
  NoContent
}


// WEBPACK FOOTER //
// ./components/no-content/index.js